import * as angular from 'angular';
import { isEmpty } from 'lodash';

export const SignInInputComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['SignInService', '$scope'];
    public email: string;
    public emailIsInvalid: boolean;
    public authEmailParam: string;
    public onEmailSubmit: ($email) => void;

    constructor(
      private SignInService,
      private $scope
    ) {}

    $onInit() {
      this.$scope.$applyAsync(() => {
        this.email = this.authEmailParam;
      });
    }

    handleKeyPress(event) {
      const code = event.which || event.keyCode || event.charCode;
      if (code === 13) {
        event.preventDefault();
        this.validateAndFetchSignInOptions();
      }
    }

    handleNextClick() {
      this.validateAndFetchSignInOptions();
    }

    validateAndFetchSignInOptions() {
      if (!isEmpty(this.email)) {
        this.emailIsInvalid = false;
        // invoke the parent components function to call options
        const $email = this.email;
        this.onEmailSubmit({ $email });
      } else {
        this.emailIsInvalid = true;
      }
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    onEmailSubmit: '&',
    authEmailParam: '<',
  },
  template: `
  <div class="sign-in-input-container">
    <label class="input-label" for="auth_key">Email or username</label>
    <div class="landing-email-input">
      <input
        name="auth_key"
        id="auth_key"
        class="form-control sign-in-email"
        autofocus="autofocus"
        maxlength="255"
        placeholder="Enter your email or username..."
        ng-model="ctrl.email"
        ng-keypress="ctrl.handleKeyPress($event)"
        data-test="email-input"
        >
      </input>
      <button
        id="next"
        class="btn btn-filled-primary"
        ng-click="ctrl.handleNextClick(ctrl.email)"
        data-test="sign-in-next"
      >
        Next
      </button>
    </div>

    <div class="form-control-error" ng-show="ctrl.emailIsInvalid" ng-cloak>
      <div>Please provide a valid email or username.</div>
    </div>
  </div>
  `,
};
